// Simple Session Management - No Overthinking!

const SESSION_KEYS = {
  USER: 'popmates_user',
  EXPIRY: 'popmates_user_expiry'
};

// Simple config - long sessions, no fuss
const SESSION_DURATION = 30 * 24 * 60 * 60 * 1000; // 30 days

export const sessionManager = {
  // Store user session - simple!
  setSession(userData) {
    try {
      const sessionExpiry = Date.now() + SESSION_DURATION;
      
      localStorage.setItem(SESSION_KEYS.USER, JSON.stringify(userData));
      localStorage.setItem(SESSION_KEYS.EXPIRY, sessionExpiry.toString());
      
      return true;
    } catch (error) {
      console.error('Failed to store session:', error);
      return false;
    }
  },

  // Get current session if valid - simple!
  getSession() {
    try {
      const storedUser = localStorage.getItem(SESSION_KEYS.USER);
      const storedExpiry = localStorage.getItem(SESSION_KEYS.EXPIRY);
      
      if (!storedUser || !storedExpiry) {
        return null;
      }

      const expiryTime = parseInt(storedExpiry);
      const currentTime = Date.now();
      
      // Check if session is still valid
      if (currentTime < expiryTime) {
        return {
          user: JSON.parse(storedUser),
          expiryTime
        };
      } else {
        // Session expired, clean up silently
        this.clearSession();
        return null;
      }
    } catch (error) {
      console.error('Error retrieving session:', error);
      this.clearSession(); // Clean up corrupted data
      return null;
    }
  },

  // Clear session data
  clearSession() {
    try {
      localStorage.removeItem(SESSION_KEYS.USER);
      localStorage.removeItem(SESSION_KEYS.EXPIRY);
      return true;
    } catch (error) {
      console.error('Failed to clear session:', error);
      return false;
    }
  },

  // Check if session exists and is valid
  isSessionValid() {
    const session = this.getSession();
    return session !== null;
  },

  // Simple session info for debugging only
  getSessionInfo() {
    const session = this.getSession();
    if (!session) {
      return { valid: false, message: 'No session found' };
    }

    const daysLeft = Math.floor((session.expiryTime - Date.now()) / (24 * 60 * 60 * 1000));

    return {
      valid: true,
      user: session.user.email,
      expiresAt: new Date(session.expiryTime).toLocaleString(),
      daysLeft: daysLeft
    };
  }
}; 